export default __webpack_public_path__ + "static/media/feature-icon-3.89a9dde8.svg";